/**
 * Lista delle org abilitate alle feature beta.
 *
 * Quando aggiungi una nuova feature in beta:
 *  1. Aggiungi `_betaOrgIds: BETA_AGENTS_ORG_IDS` al menu item in menuConfig.ts
 *  2. Aggiungi `useBetaAgentsGuard()` (o equivalente) nella pagina root della feature
 *
 * Per aprire la feature a tutti: rimuovi `_betaOrgIds` dal menu item + rimuovi il guard.
 */

/** Org abilitate al modulo "Agenti AI" (lista, organism, HITL). */
export const BETA_AGENTS_ORG_IDS: string[] = [
  '15c286d3-1217-4b10-bf99-84c05d0b8271', // Obly Mobile Test
  '4f65faa8-5c94-4dd3-b767-4e50311eba20', // OBLY DIGITAL LAB — collaudo su di noi prima dei clienti (10/09/2026)
];

/** Org abilitate al modulo "Agenti vocali" (voice agents ElevenLabs, beta). */
export const BETA_VOICE_AGENTS_ORG_IDS: string[] = [
  '4f65faa8-5c94-4dd3-b767-4e50311eba20', // OBLY DIGITAL LAB
  '15c286d3-1217-4b10-bf99-84c05d0b8271', // Obly Mobile Test
];

/** Org abilitate alla sezione "Arricchimento Lead" (/settings/enrichment). */
export const LEAD_ENRICHMENT_ORG_IDS: string[] = [
  '4f65faa8-5c94-4dd3-b767-4e50311eba20', // OBLY DIGITAL LAB
  '15c286d3-1217-4b10-bf99-84c05d0b8271', // Obly Mobile Test
  '953bb5ee-bdc3-4f88-b33f-21d747eadfe3', // Demo Obly
];

/**
 * Ritorna true se la org corrente puo' vedere la voce menu/feature beta.
 * Voci senza _betaOrgIds (o con array vuoto) sono sempre visibili.
 */
export function canAccessBetaFeature(
  betaOrgIds: string[] | undefined,
  currentOrgId: string | null | undefined,
): boolean {
  if (!betaOrgIds || betaOrgIds.length === 0) return true;
  if (!currentOrgId) return false;
  return betaOrgIds.includes(currentOrgId);
}
